const getBrowserLanguage = () =>
  typeof navigator !== 'undefined' ? (navigator.languages && navigator.languages[0]) || navigator.language : 'en';

export const useBrowserLanguage = () => {
  let browserLanguage = getBrowserLanguage();

  if (!['de'].includes(browserLanguage)) {
    browserLanguage = 'en';
  }

  return browserLanguage;
};
